import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducers from './reducers';

export default function appStore() {
    const composeEnhancers = composeWithDevTools(
        applyMiddleware(thunk)
    );

    const store = createStore(reducers, composeEnhancers);

    return store;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/store.ts